<template>
    <v-container fluid class="pa-0" v-if="usuario">
      <vueHeadful
      :title="usuario.nombre + ' - TrArtist'"
      :description="usuario.biografiaEs"
      :image="usuario.fotoPerfil"
      :url="'https://trartist.com' + $route.fullPath"
      />
        <v-row style="max-width: 100%; margin: 0">
          <v-col cols="12" align="center" style="padding: 60px 20%">
              <h1 :style="responsiveTitulo">{{usuario.nombre.toUpperCase()}}</h1>
          </v-col>
          <v-row :style="margenGris" v-if="usuario.fotoPerfil || usuario.videoYoutube">
            <v-col cols="12" xs="12" md="4" align="center" align-self="center" class="px-5">
              <v-img :style="marginPhoto" :src="usuario.fotoPerfil" contain />
            </v-col>
            <v-col align="center" align-self="center" cols="12" xs="12" md="8" v-if="usuario.videoYoutube">
              <iframe :style="marginVideo" width="96%" :height="videoHeight" :src="`https://www.youtube.com/embed/${usuario.videoYoutube}`" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </v-col>
          </v-row>
          <v-col cols="12" :style="margenContenedor">
              <h2 class="descripcion font-weight-light pb-5">{{$t('Menu.Biografia')}}</h2>
              <p class="descripcion font-weight-bold">{{ usuario.ciudad }} - {{ getPaises[usuario.pais - 1].name }}</p>

              <!-- <p style="margin-bottom: 2rem; white-space:pre-wrap;">{{usuario.biografiaEs}}</p> -->
              <p class="descripcion font-weight-light text-justify" :style="margenBiografia" v-if="getIdioma === 'es'">{{usuario.biografiaEs}}</p>
              <p class="descripcion font-weight-light text-justify" :style="margenBiografia" v-if="getIdioma === 'en'">{{usuario.biografiaEn}}</p>
              <v-col cols="12" align="center" style="margin: 70px 0" v-if="usuario.redesSociales[0]">
                <a
                v-for="(redes, index) in usuario.redesSociales"
                :key="index"
                :href="redes.enlace"
                target="_blank"
                style="text-decoration:none;"
                class="mx-5">
                  <v-icon class="ma-2" size="40" color="primary">{{redes.icono}}</v-icon>
                </a>
              </v-col>
          </v-col>
        </v-row>
        <v-row style="margin: 0 20%">
          <v-col cols="12" align="center" v-if="!productos[0]">
            <h3>{{$t('Formularios.UsuarioSinProducto')}}</h3>
          </v-col>
          <v-col cols="12" style="padding-bottom: 60px;" name="Productos" v-else>
            <v-row>
              <v-col cols="12" xs="12" sm="6" md="4" lg="4" v-for="(i, index) in productos" :key="i.uid">
                <v-row>
                  <v-col cols="12" @click="verProducto(i.uid)">
                    <div style="background: black;">
                      <v-hover v-slot:default="{ hover }">
                        <v-img :id="hover ? 'imagen' : ''" :src="i.imagenPrincipal" width="100%" aspect-ratio="1"/>
                      </v-hover>
                    </div>
                  </v-col>
                  <v-col cols="9" class="py-0">
                    <v-row>
                      <v-col cols="12" class="pb-0">
                        <span style="font-size:15px;">{{ i.titulo.toUpperCase() }}</span>
                      </v-col>
                      <v-col cols="12" class="py-0">
                        <span style="font-size:15px;color:#bdbdbd;">{{ $t('Busqueda.Largo')}} {{ i.dimensiones.largo }}cm x {{ $t('Busqueda.Ancho')}} {{ i.dimensiones.ancho }}cm x {{ $t('Busqueda.Alto')}} {{ i.dimensiones.alto }}cm</span>
                      </v-col>
                      <div v-if="i.exponer" cols="12" class="pb-0 pt-4 pl-3">
                        <span style="font-size:15px;" class="font-weight-bold">{{ $t('Formularios.Exhibicion').toUpperCase() }}</span>
                      </div>
                      <div v-else>
                        <v-col cols="12" class="pb-0 pt-4" v-if="i.fisico">
                          <span style="font-size:15px;" class="font-weight-bold black--text">${{ i.precioPago ? Number(i.precioPago).toLocaleString() : 0 }}</span>
                        </v-col>
                        <v-col cols="12" class="pb-0 pt-4" v-if="i.digital">
                          <span style="font-size:15px;" class="font-weight-bold black--text">${{ i.precioPagoDig ? Number(i.precioPagoDig).toLocaleString() : 0 }}</span>
                        </v-col>
                      </div>
                    </v-row>
                  </v-col>
                  <v-col cols="2" align="center" class="pa-0">
                    <v-row class="pa-0">
                      <v-col cols="6" class="pa-0" align="right">
                        <v-btn icon @click="meGusta({uid: i.uid, index})" :color="i.mg ? 'red' : 'secondary'"><v-icon>fas fa-heart</v-icon></v-btn>
                      </v-col>
                      <v-col cols="6" class="pa-0">
                        <v-menu name="Carrito" open-on-hover offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on" color="black"><v-icon>fas fa-shopping-cart</v-icon></v-btn>
                          </template>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import vueHeadful from 'vue-headful'
export default {
  name: 'Usuarios',
  props: ['nombreDeUsuario'],
  components: {
    vueHeadful
  },
  data () {
    return {
      usuario: [],
      productos: []
    }
  },
  methods: {
    verProducto (uid) {
      this.$router.push('/p/' + uid)
    }
  },
  mounted () {
    // console.log('hola', this.nombreDeUsuario)
    firebase.firestore().collection('usuarios').where('nombreDeUsuario', '==', this.nombreDeUsuario).get().then(info => {
      this.usuario = info.docs[0].data()
      firebase.firestore().collection('productos').where('artista.uid', '==', this.usuario.uid).where('aprobado', '==', true).get().then(info => {
        for (let i = 0; i < info.docs.length; i++) {
          this.productos.push(info.docs[i].data())
        }
      })
    })
  },
  computed: {
    ...mapGetters(['getPaises', 'getIdioma']),
    responsiveTitulo () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'font-size:3rem;line-height:3rem;'
        case 'sm': return 'font-size:3rem;line-height:3rem;'
        case 'md': return 'font-size:3.5rem;line-height:3.5rem;'
        case 'lg': return 'font-size:4rem;line-height:4rem;'
        case 'xl': return 'font-size:4rem;line-height:4rem;'
        default: return 'font-size:4rem;line-height:4rem;'
      }
    },
    margenGris () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'padding: 20px 10%;margin:0 10%;background-color: #e5e5e5;max-width:80%;'
        case 'sm': return 'padding: 20px 10%;margin:0 10%; background-color: #e5e5e5;max-width:80%;'
        case 'md': return 'padding: 40px 10%;margin: 0 10%; background-color: #e5e5e5;max-width:80%;'
        case 'lg': return 'padding: 40px 2%;margin: 0 10%; background-color: #e5e5e5;max-width:79%;'
        case 'xl': return 'padding: 40px 4%;margin: 0 10%; background-color: #e5e5e5;max-width:80%; height: 100%;'
        default: return 'padding: 40px 10%;margin: 0 10%; background-color: #e5e5e5;max-width:80%;'
      }
    },
    videoHeight () {
      if (this.$vuetify.breakpoint.name === 'xl') {
        return '550px'
      } else {
        return '400px'
      }
    },
    marginVideo () {
      if (this.$vuetify.breakpoint.name !== 'xs' && this.$vuetify.breakpoint.name !== 'sm') {
        return 'margin-left: 15px'
      } else {
        return 'margin-left: 0px'
      }
    },
    marginPhoto () {
      if (this.$vuetify.breakpoint.name !== 'xs' && this.$vuetify.breakpoint.name !== 'sm') {
        return 'margin-right: 25px'
      } else {
        return 'margin-right: 0px'
      }
    },
    margenContenedor () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'padding: 0 10%;margin-top: 60px; font-size: 16px; !important'
        case 'sm': return 'padding: 0 20%;margin-top: 60px; font-size:20px'
        case 'md': return 'padding: 0 20%;margin-top: 60px'
        case 'lg': return 'padding: 0 20%;margin-top: 60px'
        case 'xl': return 'padding: 0 20%;margin-top: 60px'
        default: return 'padding: 0 20%;margin-top: 60px'
      }
    },
    margenBiografia () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'font-size: 18px; line-height:2rem; white-space:pre-wrap;'
        case 'sm': return 'font-size: 20px; line-height:2rem; white-space:pre-wrap;'
        case 'md': return 'line-height: 3rem; white-space:pre-wrap;'
        case 'lg': return 'line-height: 3rem; white-space:pre-wrap;'
        case 'xl': return 'line-height: 3rem; white-space:pre-wrap;'
        default: return 'line-height: 3rem; white-space:pre-wrap;'
      }
    }
  }
}
</script>

<style scoped>
.letraRotada {
  font-size: 5rem;
  font-weight: 100;
  letter-spacing: 10px;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  color: rgba(38, 166, 153, 0.658);
  font-family: 'Be Vietnam', sans-serif!important;
  inline-size: min-content;
}
</style>
